import { merge } from 'icepick';
import { type PersonalizationState } from './types';
import { type AnyAction } from 'redux';
import { UPDATE_PERSONALIZATION_SITE_TRAITS } from '../actions/personalization-site-traits';

export const initialPersonalizationState: PersonalizationState = {
	siteTraits: [],
};

export default (
	state: PersonalizationState = initialPersonalizationState,
	action: AnyAction,
): PersonalizationState => {
	switch (action.type) {
		case UPDATE_PERSONALIZATION_SITE_TRAITS:
			return merge(state, {
				siteTraits: action.traits,
			});

		default:
			return state;
	}
};
